import React from 'react';
import Header from './Header';
import Content from './Content';

const Home = () => (
  <div>
    <Header />
    <Content />
  </div>
);

export default Home;
